import { Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../../components/Accessibility/PageTitle";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const TranscricaoSolicitacao: React.FC = () => {
  const navigate = useNavigate();
  const accessibility = useAccessibility();

  return (
    <div className="transcricao-content-holder">
      <PageTitle text="Transcrição de solicitação" />

      <p
        className="transcricao-description"
        style={accessibility.textStyleAccessibility}
      >
        Aqui você irá realizar novas transcrições, e consultar as transcrições
        já realizadas.
      </p>

      <div className="transcricao-buttons-holder">
        <div className="transcricao-option-button">
          <Button
            fullWidth
            onClick={() =>
              navigate("/guiasEautorizacoes/transcricaoSolicitacao/novaTranscricao")
            }
            style={{
              ...accessibility.contrastStyle,
              ...accessibility.contrastBorderAccessibility,
            }}
          >
            <Typography style={accessibility.textStyleAccessibility}>
              Nova transcrição
            </Typography>
            <FontAwesomeIcon
              icon={faChevronRight}
              style={accessibility.textStyleAccessibility}
              color="#383838"
            />
          </Button>
        </div>

        <div className="transcricao-option-button">
          <Button
            fullWidth
            onClick={() =>
              navigate("/guiasEautorizacoes/transcricaoSolicitacao/consultar")
            }
            style={{
              ...accessibility.contrastStyle,
              ...accessibility.contrastBorderAccessibility,
            }}
          >
            <Typography style={accessibility.textStyleAccessibility}>
              Minhas Transcrições
            </Typography>
            <FontAwesomeIcon
              icon={faChevronRight}
              style={accessibility.textStyleAccessibility}
              color="#383838"
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TranscricaoSolicitacao;